import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { User, StoredPaymentMethod } from 'models'

export type AuthState = {
  currentUser?: User
}

const initialState: AuthState = {}

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser: (state, { payload: user }: PayloadAction<User>) => {
      state.currentUser = user
    },
    updateCurrentUser: (
      state,
      { payload: userData }: PayloadAction<Partial<User>>,
    ) => {
      if (state.currentUser) {
        state.currentUser = { ...state.currentUser, ...userData }
      }
    },
    clearCurrentUser: (state) => {
      state.currentUser = undefined
    },
    updatePaymentMethods: (
      state,
      { payload: paymentMethods }: PayloadAction<StoredPaymentMethod[]>,
    ) => {
      if (state.currentUser) {
        state.currentUser = {
          ...state.currentUser,
          paymentMethods,
        }
      }
    },
  },
})

export const {
  setCurrentUser,
  updateCurrentUser,
  clearCurrentUser,
  updatePaymentMethods,
} = slice.actions

export const authReducer = slice.reducer
